module.exports = __webpack_public_path__ + "static/media/card4_2.d2e99c48.png";